import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyUploadAlbum = loadable(() => import(/* webpackChunkName: "content/guest/mediacollection/uploadalbum" */ './UploadAlbum'), 'UploadAlbum');
